import React from 'react';

import Chip from 'components/Chip/Chip';

import { colors } from 'theme/colors';

import { GroupStatusChipProps } from './types';

const GroupStatusChip: React.FunctionComponent<GroupStatusChipProps> = ({ isActive }) =>
  isActive ? (
    <Chip
      label="Active"
      size="small"
      variant="outlined"
      colors={{ background: colors.tint.success.medium, foreground: colors.toast.success.text, border: 'transparent' }}
    />
  ) : (
    <Chip
      label="Inactive"
      size="small"
      variant="outlined"
      colors={{ background: colors.action.selected, foreground: colors.text.secondary, border: 'transparent' }}
    />
  );

export default GroupStatusChip;
